<template>
    <div>
        <b-row>
            <b-col>
                <div class="container-fluid">
                <b-row>
                    <b-col>
                        <div align="center" class="mb-2">
                            <b-button 
                                variant="primary" 
                                size="sm" 
                                @click="listProformas">
                                Actualizar <i class="fa fa-sync-alt"></i>
                            </b-button>
                            <b-button
                                class="ml-2"
                                variant="primary"
                                size="sm"
                                @click="agruparPorMesa = !agruparPorMesa"
                                >
                                {{ agruparPorMesa ? 'Ver sin agrupar' : 'Agrupar por mesa' }}
                            </b-button>
                        </div>
                    </b-col>
                    <b-col md="2">
                        <b-form-group horizontal label="Mostrar" class="mb-1">
                        <b-input-group>
                            <b-form-select v-model="limit" slot="append" @input="listProformas">
                            <option :value="10">10</option>
                                <option :value="25">25</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </b-form-select>
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <template v-if="loading">
                <div class="text-center mb-5 mt-5">
                <h3>
                Cargando
                <i class="fa fa-spin fa-spinner"></i>
                </h3>
                </div>
                </template>
                <template v-else>
                <b-table
                head-variant="light"
                :outlined="outlined"
                responsive 
                small 
                :items="ordenPagoFinal" 
                :fields="ordenPago_fields"
                :tbody-tr-class="rowClass"
                >
                <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
                <template slot="actualizado" slot-scope="row">             
                    <h5><b-badge pill variant="primary">{{row.item.ordenPago.actualizado}}</b-badge></h5>
                </template>
                <template slot="serie" slot-scope="row">
                    {{row.item.serie}} - {{row.item.numero}}
                </template>
                <template slot="emision" slot-scope="row">
                    {{ row.item.created_at | moment('D/M/Y hh:mm:ss A') }}
                </template>
                <template slot="receptor" slot-scope="row">
                    {{row.item.ordenPago.receptor.nro}} - {{row.item.ordenPago.receptor.razonSocial}}
                </template>
                <template slot="tag3" slot-scope="row">
                    {{row.item.ordenPago.tag3}}
                </template>
                <template slot="usuario" slot-scope="row">
                    <template v-if="row.item.ordenPago.adicional && row.item.ordenPago.adicional.username">
                        {{row.item.ordenPago.adicional.username}}

                    </template>
                    <template v-else>
                            Sin usuario
                    </template>
                </template>
                <template slot="importetotales" slot-scope="row">     
                   <template v-if="row.item.ordenPago.moneda">
                        {{ row.item.ordenPago.moneda.simbolo }} 
                   </template>
                        {{ row.item.ordenPago.totales.importeTotal.toFixed(2) }} 
                </template>
                <template slot="nuevo" slot-scope="row"> 
                   <template v-if="row.item.ordenPago.nuevo">
                       <div>
                           <i title="OP Actualizada" class="fas fa-bell text-success"></i>
                       </div>
                   </template>
                   <template v-else-if="!row.item.ordenPago.nuevo"></template>
                </template>
                <template slot="acciones" slot-scope="row">
                    <template>
                        <button size="sm" @click="mostrarItems(row, row.index,row.item)" type="button" class="btn" title="Mas opciones">
                        <template v-if="!row.detailsShowing">
                            <i class="fa fa-plus"></i>                                
                        </template>
                        <template v-else>
                            <i class="fa fa-minus"></i>
                        </template>
                        </button>
                        <b-button-group>
                            <b-button variant="success" size="sm" style="color:#fff" @click="pagarOP(row.index, row.item)" title="Facturar"><i class="fas fa-dollar-sign"></i></b-button>
                            <b-button variant="primary" size="sm" @click="openModal(row.item)" title="Producción" ><i class="fas fa-tools"></i></b-button>
                            <b-button variant="" size="sm" @click="detalleOrdenModal(row.item)" title="Pre Cuenta"><i class="fas fa-calculator"></i></b-button>
                            <b-button variant="warning" size="sm" @click="OpenModalEdit(row.index,row.item)" title="Editar"><i class="fas fa-edit"></i></b-button>
                        </b-button-group>
                    </template>
                </template>
                <template v-slot:row-details="row">
                    <b-card>
                        <b-table 
                        head-variant="light"
                        responsive
                        small
                        :items="row.item.ordenPago.items"
                        :fields="listaitems_fields"
                        :outlined="outlined">
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Cargando...</strong>
                            </div>
                            <template slot="index" slot-scope="row">{{ row.index+1 }}</template>
                            <template slot="actualizado" slot-scope="row">             
                                <h5><b-badge pill variant="primary">{{row.item.actualizado}}</b-badge></h5>
                            </template>
                            <template slot="cantidad" slot-scope="row">
                                <div>
                                    <template v-if="row.item.cantidad">
                                        {{ Number.parseFloat(row.item.cantidad).toFixed(2) }}
                                    </template>
                                </div>
                            </template>
                            <template slot="precioVentaUnitario" slot-scope="row">
                                <div>
                                <template v-if="row.item.codigo=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                <template
                                    v-if="row.item.precioVentaUnitario"
                                >{{ Number.parseFloat(row.item.precioVentaUnitario).toFixed(2) }}</template>
                                </div>
                            </template>
                            <template slot="descuento" slot-scope="row">
                                <div>
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                    <template v-if="row.item.descuento">
                                        {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                                    </template>
                                </div>
                            </template>
                            <template slot="valorVenta" slot-scope="row">
                                <div>
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                <template v-if="row.item.tipoAfectacionIgv !='30' && row.item.tipoAfectacionIgv !='20'"
                                    >{{ Number.parseFloat(row.item.valorVenta*(row.item.porcentajeImpuesto == '18.00000' ? 1.18 : 1.105)).toFixed(2) }}
                                </template>
                                <template v-else
                                    >{{ Number.parseFloat(row.item.valorVenta).toFixed(2)}}
                                </template>
                                <div v-if="row.item.porcentajeImpuesto !='0'" style="float:right;color:red">
                                    {{row.item.porcentajeImpuesto == '18' ? '18%' : '10.5%'}}
                                </div>
                                <div v-else style="float:right;color:red">
                                    18%
                                </div>
                                </div>
                            </template >                    
                        </b-table>
                       <label v-if="row.item.ordenPago.observaciones != null" style="color:red">observaciones: </label> {{row.item.ordenPago.observaciones}} 
                       <label v-if="row.item.ordenPago.atencion != null" style="color:red">Atencion: </label> {{row.item.ordenPago.atencion}} 
                       <label v-if="row.item.ordenPago.plazoentrega != null" style="color:red">Plazo Entrega: </label> {{row.item.ordenPago.plazoentrega}} 
                       <label v-if="row.item.ordenPago.formapago != null" style="color:red">Forma de Pago: </label> {{row.item.ordenPago.formapago}} 
                       <label v-if="row.item.ordenPago.garantia != null" style="color:red">Garantia: </label> {{row.item.ordenPago.garantia}} 
                       <label v-if="row.item.ordenPago.telefono != null" style="color:red">Telefono: </label> {{row.item.ordenPago.telefono}} 
                    </b-card>
                </template>
                </b-table>
                </template>      
                </div>
                <b-row> 
                    <b-col cols="9">
                        <div>
                            <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                        </div>
                    </b-col> 
                <b-col cols="12" sm="5" md="5" lg="4" xl=3>
                    <b-pagination
                        :total-rows="total"
                        v-model="page"
                        @input="listProformas"
                        :per-page="limit"
                        align="center"
                    ></b-pagination>
                </b-col>
            </b-row>
            </b-col>
            <b-modal v-model="pagarOrdenP" size="xl" title="Orden de Pago">
            <b-row >
                <b-col  xl="2">
                    <b-form-select v-model="selected" :options="options"></b-form-select>
                </b-col>
                <b-col xl="2">
                <select  class="custom-select mr-sm-2 input-placedark input-dark" id="inlineFormCustomSelect" v-model="tipoDocumento">                       
                    <option :value="tipodocumento.tipo" v-for="tipodocumento in documentosIdentidad" v-bind:key="tipodocumento.tipo">
                        {{ tipodocumento.nombre }}
                    </option>
                </select> 
                </b-col>
                <b-col xl="3">
                    <div class="form-label-group">
                        <b-form-input type="text" :disabled="tipoDocumento==0" class="form-control address" v-model="receptor.numero" placeholder="Atencion a" autofocus @change="getReceivers()"></b-form-input>
                        <label>Documento</label>
                    </div>
                    <template v-if="cargandoreceptor">
                    <b-list-group class="searcher-field">
                        <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item>
                    </b-list-group>
                    </template>
                    <b-list-group v-if="listarec" class="searcher-field">
                    <!-- <b-list-group-item v-if="norec">No hay Receptores con ese número</b-list-group-item> -->
                    <template v-for="(item, index) in listaReceptores" class="buscarRuc">
                        <b-list-group-item :key="index" @click="setReceiver(item)" class="searcher-result">
                        {{item.idReceptor + ' - ' + item.razonSocial}}
                        </b-list-group-item>
                    </template>
                    </b-list-group>
                </b-col>
                <b-col xl="5">
                    <div class="form-label-group">
                        <b-form-input type="text" class="form-control address" @input="pitcherReceiver()" v-model="receptor.razonSocial" placeholder="Atencion a" autofocus></b-form-input>
                        <label>Razon Social</label>
                    </div>
                </b-col>
                </b-row>
                <b-row class="mt-2">
                <b-col xl="2">
                    <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="moneda">
                        <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                        {{ moneda.descripcion }}
                        </option>
                    </select>
                </b-col>
                <b-col xl="2">
                    <b-input-group>
                    <template v-if="seriesCargadas">
                    <b-button size="md" variant="secondary" outline-success>
                            Cargando Series... <i class="fa fa-spin fa-spinner"></i>
                    </b-button>
                    </template>
                    <template v-else>
                    <select class="form-control input-placedark input-dark" v-model="indexSerie">
                        <option v-for="(serie, index) in listaSeries" :value="index" :key="index">{{ serie }}</option>
                    </select>
                    </template>
                    </b-input-group>
                </b-col>                 
                <b-col xl="8">
                    <div class="form-label-group">
                        <b-form-input type="text" class="form-control address" v-model="receptor.direccion" placeholder="Dirección" autofocus></b-form-input>
                        <label>Dirección</label>
                    </div>
                </b-col>
            </b-row>
            <b-row >  
                <b-col class="bordes pagos">
                    <totales @loadtotal="insertTotal" :items="items" :monedabuffer="moneda"></totales>
                </b-col>   
                <b-col xl="6">
                        <!-- PDV Comercio | v-if="pdv == 0"  -->
                    <div class="bordes pagos">
                        <b-row>
                            <b-col>
                                <div class="text-center">
                                    <b>FORMAS DE PAGO</b>
                                </div>
                            </b-col>
                        </b-row><br>
                        <b-row>
                            <b-col xl="6">
                            <b-input-group>
                            <b-button v-if="formadepago.codigo =='00'"  v-b-tooltip.hover="'ver cuotas crédito'" style="border:none" variant="outline-primary" class="sinresultados mr-1" size="sm" @click="vercreditos()"><i class="fas fa-eye"></i></b-button>
                            <select class="custom-select  input-placedark input-dark" v-model="formadepago">
                                <option :value="fpago" v-for="fpago in formaPago" v-bind:key="fpago.codigo">
                                    {{ fpago.nombre }}
                                </option>
                            </select>
                            </b-input-group>
                            </b-col>
                            <b-col xl="6">
                                <b-form-input placeholder="0.00" v-model="fpago" @keyup.enter="addPago()"></b-form-input>
                            </b-col>
                        </b-row><br>
                        <b-row>
                            <b-col xl="12">
                                <b-list-group>
                                    <b-list-group-item v-for="(pago, index) of listaPagos" :key="index">
                                        <b-row>
                                            <b-col xl="6">
                                                {{ pago.descripcion.substring(0,10) }}...
                                            </b-col>
                                            <b-col xl="1">
                                                {{ moneda.simbolo }}
                                            </b-col>
                                            <b-col xl="3">
                                                {{ pago.monto }}
                                            </b-col>
                                            <b-col xl="1">
                                                <i @click="removePago(index)" class="fa fa-times-circle text-danger"></i>
                                            </b-col>      
                                        </b-row> 
                                    </b-list-group-item>
                                </b-list-group>
                            </b-col>
                        </b-row><hr>
                        <b-row>
                            <b-col xl="6">
                                <b>Pagos</b>
                            </b-col>
                            <b-col xl="1">
                                {{ moneda.simbolo }}
                            </b-col>
                            <b-col xl="4">
                                {{ accumulatePagos() }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col xl="6">
                                <b>Vuelto</b>
                            </b-col>
                            <b-col xl="1">
                                {{ moneda.simbolo }}
                            </b-col>
                            <b-col xl="4">
                                {{ vuelto.toFixed(2) }}
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
            <hr>
            <b>Usuario: |</b> {{usuario}}
            <hr>
            <b>Observaciones: |</b> {{observer}}
            <template v-if="selected !=12" slot="modal-footer">         
                <b-col cols="3">
                    <b-button style="width:100%" v-if="!emitiendo" :disabled="validarPago()" @click="validarImporteTotal()" variant="primary"><i class="fa fa-paper-plane"></i> Emitir {{doc}}</b-button>
                    <b-button style="width:100%" v-else disabled size="sm" variant="primary"><i class="fa fa-paper-plane"></i> Emitiendo <i class="fa fa-spin fa-spinner"></i></b-button>
                </b-col>
            </template>
            <template v-else>
                <b-col cols="3" slot="modal-footer">
                    <b-button style="width:100%" v-if="!emitiendo" :disabled="validarPago()" @click="validarImporteTotal()" variant="primary"><i class="fa fa-paper-plane"></i> Emitir {{doc}}</b-button>
                    <b-button style="width:100%" v-else disabled size="sm" variant="primary"><i class="fa fa-paper-plane"></i> Emitiendo <i class="fa fa-spin fa-spinner"></i></b-button>
                </b-col>
            </template>
            </b-modal>
            <b-modal size="xs" v-model="modalimpresion">
                <template slot="modal-header">
                    <div class="text-center">
                    Telemovil
                    </div>
                </template>
                <template>
                    <plantilla :impresion="dataImpresion" :printweb="printweb"></plantilla>
                </template>
                <template slot="modal-footer">   
                    <b-button size="sm"  class="btn btn-info" @click="print()"><i class="fas fa-print"></i> Imprimir</b-button>
                    <b-button size="sm" class="btn btn-success" @click="nuevaImpresion()"><i class="fas fa-plus"></i> Nuevo</b-button>
                </template>
        </b-modal>
        <b-modal size="sm" v-model="comandaImpresion">
            <template slot="modal-header">
                <div class="text-center">
                    Impresion de Pedido
                </div>
            </template>
            <print-comanda :dataitem="datosComanda" :printComand="printComand" ></print-comanda>
            <template slot="modal-footer">   
                <b-button size="sm" variant="primary" @click="ImprimirComanda()"><i class="fas fa-print"></i> Imprimir</b-button>
                <b-button size="sm" variant="" @click="cerrarComanda()">Cerrar</b-button>
            </template>
        </b-modal>
        <b-modal size="" v-model="detalleOrden">
            <template slot="modal-header">
                <div class="text-center">
                    Detalle de Orden
                </div>
            </template>
             <detalle-orden-caja :detallesorden="dataorden" :printOrden="printOrden" ></detalle-orden-caja>
             <template slot="modal-footer">   
                <b-button size="sm" variant="primary" @click="imprimirOrden()"><i class="fas fa-print"></i> Imprimir</b-button>
                <b-button size="sm" variant="" @click="cerrarOrden()">Cerrar</b-button>
            </template>
        </b-modal>
        <!-- pago de cuotas -->
        <b-modal size="lg" v-model="modalCredito">
      <b-row class="mb-2">
        <b-col cols="4">
          <datepicker class="input-placedark input-dark"
            v-model="fechaPagoCuota"
            :language="es"
            :format="customFormatter"
            :bootstrap-styling="true"
            placeholder="Fecha de Vencimiento"
          ></datepicker>
        </b-col>
        <b-col cols="4">
          <b-input class="text-center"
            type="number"
            v-model="montoPagoCuota"
            @keyup.enter='addcuota()'
            placeholder="Monto cuota"
          ></b-input>
        </b-col>
        <b-col>
          <b-button class="mt-1" variant="primary" size="sm" :disabled="validarcredito" @click="addcuota()"><i class="fas fa-plus"></i></b-button>
        </b-col>
      </b-row>
      <template slot="modal-header">
        <h5>Cuotas Crédito</h5>
      </template>
     <b-table
     :outlined="outlined"
      small   
      :items="cuotasCredito" 
      :fields="cuotas_credito">
      <template slot="acciones" slot-scope="row">
          <b-button variant="outline-danger" style="border:none"  size="sm" @click="deletecuota(row.index)"><i class="fas fa-trash"></i></b-button>
      </template>
     </b-table>
     <template>
       <div slot="modal-footer" class="w-100">
         <b-row>
         <b-col cols="12" sm="12" md="10" lg="10" xl="10" >  
           <div style="color:">
             <h5>Total Credito : {{totalcredito}}</h5>
           </div>
         </b-col>
         <b-col cols="12" sm="12" md="2" lg="2" xl="2">
           <b-button variant="primary" @click="modalcredito()">Cerrar</b-button>
         </b-col>
       </b-row>
       </div> 
      </template>
    </b-modal>
    <b-modal size="xl" v-model="editItems">
       <b-row>
            <b-col>
                <items :dataitem="dataitem" :igvGlobal="igvGlobal" @captureitem="insertItem"></items>  
            </b-col>  
        </b-row>
        <b-row>
            <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                <template>
                    <div>
                    <b-table responsive
                        small
                        striped
                        :outlined="outlined"
                        :items="items"
                        :fields="fields"
                        >
                        <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
                        <template slot="acciones" slot-scope="row">
                        <b-button class="btn btn-sm btn-group btn-outline-primary acciones-espacio" @click="updateItem(row.index, row.item)"><i class="fa fa-edit primary"></i></b-button>
                        <b-button class="btn btn-sm btn-group btn-outline-danger" @click="deleteItem(row.index)"><i class="fa fa-trash danger"></i></b-button>
                        </template>
                    </b-table>
                    </div>
                </template>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="0" sm="0"	md="8"	lg="8"	xl="3">
                <select class="custom-select" v-model="tag3">
                    <option value=""> Seleccione Etiqueta </option>
                    <option v-for="tag in listaTag" v-if="tag.numeroTag == 3" :key="tag.id" :value="tag.idTag">{{ tag.tag }}</option>
                </select>
            </b-col>
            <b-col cols="0" sm="0"	md="8"	lg="8"	xl="5"></b-col>
            <b-col cols="12" sm="12"	md="4"	lg="4"	xl="4">
                <totales @loadtotal="insertTotal" :items="items" :monedabuffer="moneda" :identificadorPro="identificadorPro"></totales>
            </b-col>
        </b-row>
        <template slot="modal-footer">
            <b-button variant="warning" @click="updateProforma()">Editar</b-button>
        </template>
    </b-modal>
        </b-row>
        <vue-snotify></vue-snotify>
    </div>
</template>
<script>
import axios from 'axios'
import Totales from '@/components/comunes/Totales'
import { FormaPagoPDV } from '@/shared/utils'
import { TipoMoneda } from '@/shared/utils'
import { DocumentosIdentidad } from '@/shared/utils'
import Plantilla from '@/components/comunes/PlantillaImpresion'
import PrintComanda from '@/components/comunes/PrintComanda'
import DetalleOrdenCaja from '@/components/comunes/DetalleOrdenCaja'
import { es } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";
import Items from '@/components/comunes/Items'
export default {
    name:'OrdenPagoCaja',
    props: ['changeOrdenPago'],
    components:{
        Datepicker,
        Totales,
        Plantilla,
        PrintComanda,
        DetalleOrdenCaja,
        Items
    },
    data:()=>{
        return{
            currentpage:1,
            page:1,
            limit:10,
            orden:'desc',
            ordenPago:[],
            ordenPago_fields: [
                {key: 'index', label: 'Nro', sorteable: true},
                {key: 'serie', label: 'Serie - Num.', sorteable: true},
                {key: 'actualizado', label: '', sorteable: true},
                {key: 'emision', label: 'Emisión', sorteable: true},            
                {key: 'receptor', label: 'Receptor', sorteable: true},
                {key: 'tag3', label: 'Etiqueta', sortable: true},
                {key: 'usuario', label: 'Usuario', sorteable: true},
                {key: 'importetotales', label: 'Monto Total', sorteable: true},
                {key: 'nuevo', label: '', sorteable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            listaitems_fields: [
                { key: "index" },
                { key: "codigoProducto", label: "Codigo", sorteable: true },
                { key: "unidadMedidaCantidad", label: "Unidad", sorteable: true },
                { key: 'actualizado', label: '', sorteable: true},
                { key: "descripcion", label: "Descripción", sorteable: true },
                { key: "observacionItem", label: "Observacion", sorteable: true },
                { key: "cantidad", label: "Cantidad", sorteable: true },
                { key: "precioVentaUnitario", label: "Precio Unit", sorteable: true },
                { key: "descuento", label: "Descuento", sorteable: true },
                { key: "valorVenta", label: "Precio Total", sorteable: true }
            ],
            total: 0.00,
            desde: 0.00,
            hasta: 0.00,
            pagarOrdenP:false,
            totales:{},
            items:[],
            moneda: '',
            moneda: {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
            },
            formadepago: {
                codigo: "008",
                nombre: 'Efectivo ventas menores'
            },
            fpago: '',
            formaPago: FormaPagoPDV,
            listaPagos: [],
            pago: 0.00,
            vuelto: 0.00,
            selected:0,
            options: [
                { value: 1, text: '(F) Factura' },
                { value: 2, text: '(B) Boleta' },
                { value: 12, text: '(NV) Nota de Venta' },                  
            ],
            tdocdisabled: false,
            tipoDocumento:0,
            receptor: {
                tipo: '',
                nro: '',
                razonSocial: '',
                direccionFiscal: ''
            },
            cargandoreceptor:false,
            rucValid: true,
            listarec: true,
            listaReceptores: [],
            tipoMoneda: TipoMoneda,
            seriesCargadas: false,
            indexSerie: 0,
            listaSeries: [],
            documentosIdentidad: DocumentosIdentidad,
            doc:'',
            ticket: {
                email: [],
                tipoOperacion: '',
                serie: '',
                montoTotalImpuestos: 0.00,
                totalVentaGravada: 0.00,
                totalVentaExonerada: 0.00,
                sumatoriaIgv: 0.00,
                importeTotal: 0.00,
                adicional: {
                    dirAlternativa: '',
                    tipo_igv:''
                },
                items: [],
                receptor: {
                    tipo: '',
                    nro: '',
                    razonSocial: '',
                    direccionFiscal: ''
                },
            },
            montoTotalImpuestos:0.00,
            gravado:0.00,
            importeTotal:0.00,
            femision: '',
            fvencimiento:'',
            listaCorreos: [],
            dataImpresion: {},
            modalimpresion: false,
            printweb: false,  
            pagar:false,
            array:[],
            generarOP:false, 
            sistema:"facturaonline",
            idOrdenPago:'', 
            outlined:true, 
            loading:true,
            usuario:'',
            outlined:true,
            observer:'',
            pagado:0,
            user:'',
            emitiendo: false,
            comandaImpresion:false,
            datosComanda:{},
            printComand:false,
            detalleOrden:false,
            dataorden:{},
            printOrden:false,
            previsualizar:true,
            modalCredito:false,
            cuotasCredito:[],
            cuotas_credito:[
                {key:'identificadorCuota',label:'Cuotas'},
                {key:'fechaPagoCuota', label:'Fecha Vencimiento'},
                {key:'montoPagoCuota', label:'Monto',},      
                {key:'acciones', label:'Agregar'}
            ],
            totalcredito:0.0,
            fechaPagoCuota:'',
            montoPagoCuota:'',
            validarcredito:true,
            es: es,
            notaVenta: {
                receptor: {
                  tipo: '',
                  nro: '',
                  razonSocial: '',
                  direccionFiscal: ''
                },
                adicional: {
                    tipo_igv:''
                },
                moneda: '',
                plazoentrega: '',
                formapago: '',
                garantia: '',
                telefono: '',
                atencion: '',
                observaciones: ''
            },
            plazoentrega: '',
            formapago: '',
            garantia: '',
            telefono: '',
            atencion: '',
            editItems:false,
            dataitem: {
                estado: false,  // Bandera logica de si se esta usando este arreglo
                tipo: 1,        // 1: actualizar; 2: borrar; 3: cargar masiva
                index: 0,       // Posicion en el array para actualizar o borrar
                item: {},
                idReceptor: ''
            },
            editItemsOp:{},
            fields: [
                {key: 'index', label: 'Item'},
                {key: 'cantidad', label: 'Cantidad', sortable: true},
                {key: 'descripcion', label: 'Descripción', sortable: true},
                {key: 'valorUnitario', label: 'Valor Unitario', sortable: true},
                {key: 'descuento', label: 'Descuento', sortable: true},
                {key: 'montoAfectacionIgv', label: 'Igv', sortable: true},
                {key: 'valorVenta', label: 'Valor Total', sortable: true},
                {key: 'acciones', label: 'Acciones', sortable: true}
            ],
            ordenpago: {
                receptor: {
                  tipo: '',
                  nro: '',
                  razonSocial: '',
                  direccionFiscal: ''
                },
                adicional: {},
                moneda: '',
                plazoentrega: '',
                formapago: '',
                garantia: '',
                telefono: '',
                atencion: '',
                observaciones: '',
                tag3:'',
                sistema:'facturaonline'
            },
            tag3:'',
            idMovil:'',
            identificadorPro: 0,
            listaTag:[],
            actualizado:0,
            nuevo:false,
            igvGlobal:'',
            tagOriginal:'',
            agruparPorMesa: false,
            idTagOP: '',
        }
    },
    mounted(){
        this.listProformas(),
        this.initDocument(),
        this.getSeries(),
        this.listTag()

    },
    computed: {
        ordenPagoFinal() {
            if (!this.agruparPorMesa) {
            return this.ordenPago; // normal
            }

            const grupos = {};

            this.ordenPago.forEach(item => {
            const mesa = item.ordenPago && item.ordenPago.tag3
                ? item.ordenPago.tag3
                : 'Sin mesa';

            if (!grupos[mesa]) {
                grupos[mesa] = [];
            }
            grupos[mesa].push(item);
            });

            return Object.keys(grupos)
            .sort()
            .flatMap(mesa => grupos[mesa]);
        }
    },
    watch:{
        comandaImpresion(){
            if(this.comandaImpresion == false){
              
            }
        },
        selected: function () {
            this.getSeries()
            if(this.selected==1){
                this.tipoDocumento = '6'
                this.tdocdisabled = true
                this.doc = "Factura"
            }else if(this.selected==2){
                if(this.receptor.tipo == '0'){
                    this.tipoDocumento = '0'
                    this.tdocdisabled = true
                    this.doc = "Boleta"
                }else{
                    this.tipoDocumento = '1'
                    this.tdocdisabled = true
                    this.doc = "Boleta"
                }
            }else if(this.selected==12){
                this.doc = "Nota Venta"
            }
        },
        'receptor.numero': function () {
            if(this.receptor.numero==''){
                this.initReceptor()
            }
        },
        'receptor.razonSocial': function () {
            if(this.receptor.razonSocial==''){
                this.initReceptor()
            }
        },
        modalimpresion: function () {
                if(this.modalimpresion == false){
                    this.printweb = false
                }
            },
         pagarOrdenP:function(){
             if(this.pagarOrdenP == false){
                 this.listaPagos = []
             }
         },
        formadepago(){
            if(this.formadepago.codigo == '000'){
                this.previsualizar = true
            }else{
                this.previsualizar = false
                if(this.formadepago.codigo == '00'){
                    this.modalCredito = true;
                }
            }
        },
        montoPagoCuota(){
          if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
            this.validarcredito = false
          }else{
             this.validarcredito = true
          }
        },
        fechaPagoCuota(){
          if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
            this.validarcredito = false
          }else{
             this.validarcredito = true
          }
        },
        tag3(){
            this.idMovil = this.tag3.idTag
        },
    },  
    methods:{
        customFormatter: function(date) {
            return this.$moment(date).format("YYYY-MM-DD HH:mm:ss");
        },
        openModal(item){
            this.datosComanda = item
            this.comandaImpresion = true;
        },
        ImprimirComanda(){
            this.printComand = true
        },
        cerrarComanda(){
            this.comandaImpresion = false;
            this.printComand = false
        },
        // DETALLE DE ORDEN
        detalleOrdenModal(item){
            this.dataorden = item
            this.detalleOrden = true;
        },
        imprimirOrden(){
            this.printOrden = true
        },
        cerrarOrden(){
            this.detalleOrden = false;
            this.printOrden = false
        },
        validarPago(){
            let serie = ''
                let pago = false
                let totalpagado = Math.round(parseFloat(this.pago)*100)/100
                let importe = Math.round(parseFloat(this.totales.importeTotal)*100)/100
                totalpagado>=importe ? pago = true: pago = false
                this.indexSerie==0 ? serie = this.listaSeries[0]: serie = this.listaSeries[this.indexSerie]
                switch(this.selected){
                    case 1: 
                        if(pago){
                            return false
                        }else{
                            return true
                        }
                        break;
                    case 2:
                        if(pago){
                            return false
                        }else{
                            return true
                        }
                        break;
                    case 12:
                        if(pago){
                            return false
                        }else{
                            return true
                        }
                        break;
                }
        },
        listProformas: function () {
            this.loading = true
            axios
            .post(process.env.VUE_APP_API_URL + 'ordenpago/listar', {
                token: this.$store.getters.userToken,
                page: this.page,
                limit: this.limit,
                order: this.orden,
                sistema:this.sistema,
                pagado:this.pagado
            })
            .then(response => (
                this.loading = false,
                this.ordenPago = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to
            ))
            .catch(error => {
                this.$snotify.error(error.response.data.msg,'Error')
            })
        },
        pagarOP(index,value){
            this.user = value.ordenPago.adicional.username
            this.observer = value.ordenPago.observaciones
            this.usuario = value.ordenPago.adicional.username
            this.items = value.ordenPago.items 
            this.receptor.numero = value.ordenPago.receptor.nro,
            this.receptor.razonSocial = value.ordenPago.receptor.razonSocial,
            this.receptor.direccion = value.ordenPago.receptor.direccionFiscal,
            this.montoTotalImpuestos = value.ordenPago.totales.montoTotalImpuestos
            this.gravado = value.ordenPago.totales.totalVentaGravada
            this.importeTotal = value.ordenPago.totales.importeTotal
            this.listaCorreos = value.ordenPago.email
            this.moneda.codigo = value.ordenPago.moneda.codigo
            this.receptor.tipo = value.ordenPago.receptor.tipo
            this.pagarOrdenP = true
            this.idOrdenPago = value.idOrdenPago
            if(value.ordenPago.receptor.tipo=='6'){
                this.selected = 1
                this.doc = "Factura"
            }else if( value.ordenPago.receptor.tipo=='1'){
                this.selected = 2
                this.doc = "Boleta"
            }else if(value.ordenPago.receptor.tipo=='0'){
                this.selected = 2
                this.tipoDocumento = '0'
            }
        },
        insertTotal: function (value) {
            if(value){
              this.totales = value
            }
          },
        addPago: function () {
            let pago = {
                descripcion: '',
                monto: 0.00
            }
            if(this.fpago != '' && this.formadepago.codigo != '000'){
                pago.descripcion = this.formadepago.nombre
                pago.monto = this.fpago
            if(this.validatePago()){
                this.listaPagos.push(pago)
                this.fpago = ''
                pago = {}
                this.accumulatePagos()
            }
            }else{
                this.$snotify.warning("Elegir una forma de pago y agregar un monto","Atencion")
                }
            },
            validatePago: function () {
                if( parseFloat(this.fpago) > 0 ){
                    return true
                }else{
                    this.$snotify.warning('El pago debe ser mayor a cero!', 'Cuidado')
                    return false
                }
            },
            accumulatePagos: function () {
                let sumapagos = 0.00
                this.listaPagos.forEach(function (element){
                    sumapagos += parseFloat(element.monto)
                })
                this.pago = sumapagos
                this.pago>=this.totales.importeTotal && this.totales.importeTotal>0 ? this.vuelto = this.pago - this.totales.importeTotal: this.vuelto = 0.00
                return this.pago.toFixed(2)
            },
            removePago: function (index) {
                this.listaPagos.splice(index,1)
            },
            getReceivers: function () {
                this.cargandoreceptor = true
                this.selected==1 ? this.receptor.tipo = '6': this.receptor.tipo = '0'
                if(this.receptor.numero.length >= 3){
                this.stateReceptorRuc(this.receptor.numero)
                if((this.rucValid && this.selected==1) || (this.selected==2) || (this.selected==12)){
                this.listarec = true
                // lista/razonSocial
                    axios
                    .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros',{
                    token: this.$store.getters.userToken,
                    q: this.receptor.numero,
                    tipoRec: this.tipoDocumento
                    })
                    .then(response => (
                    this.listaReceptores = response.data,
                    this.cargandoreceptor = false,
                    this.receivercount(this.listaReceptores.length)
                    ))
                    .catch(error => (
                    this.listaReceptores = [],
                    this.cargandoreceptor = false,
                    this.listarec = false
                    // this.norec = false
                    ))
                }  
                }else if(this.receptor.numero.length === 0){
                this.listaReceptores = [],
                this.cargandoreceptor = false
                }else{
                this.listaReceptores = []
                }    
            },
            stateReceptorRuc (value) {
                let expreg = new RegExp('\\s|<|>|[A-Za-z]|^[3-9]|^[0]')
                if(this.selected == 1){
                    if(value.length == 0){
                        this.rucValid = false
                    } else if (expreg.test(value)) {
                        this.$snotify.error('RUC Inválido','Error');
                        this.rucValid = false
                    } else {        
                        this.rucValid = true       
                    }   
                }
            },
            receivercount: function (value){
                if(value.length === 0)
                {
                this.$snotify.warning('No se encontró al receptor', 'Atención')
                }
            },
            setReceiver: function (item) {
                this.receptor.numero = item.idReceptor,
                this.receptor.tipo = item.tipo,
                this.receptor.razonSocial = item.razonSocial,
                this.receptor.direccion = item.direccionReferencia,
                this.direcciones = item.direcciones,
                this.listaCorreos = item.email,
                this.listarec = false
                if(item.tipo =="1"){
                    this.tipoDocumento = 1
                }else if(item.tipo =="6"){
                    this.tipoDocumento = 6
                }
                this.listaReceptores = []
            },
            pitcherReceiver: function () {
                if(this.receptor.razonSocial.length >= 3 ){
                    setTimeout(() => this.getReceiversByRSocial(), 200);
                }else if(this.receptor.razonSocial.length <= 2){
                    this.initReceptor()
                }  
            },
            getReceiversByRSocial: function () {
                if(this.receptor.razonSocial.length>=3 && this.tipoDocumento !=''){
                    this.cargandoreceptor = true
                    this.listarec = true
                axios
                .post(process.env.VUE_APP_API_URL + 'receptores/lista/razonsocial',{
                    token: this.$store.getters.userToken,
                    q: this.receptor.razonSocial,
                })
                .then(response => (
                    this.listaReceptores = response.data.response,
                    this.cargandoreceptor = false,
                    this.receivercount(this.listaReceptores.length)
                ))
                .catch(function (error){
                    this.cargandoreceptor = false
                })
                }else{
                this.listaReceptores = [],
                this.cargandoreceptor = false
                }
            },
            initReceptor: function () {
                this.receptor = {
                    numero:'',
                    tipo:'6',
                    direccion:'',
                    nombre:'',
                    direccionReferencia: ''
                },
                this.listaReceptores = [],
                this.cargandoreceptor = false
            },
            getSeries: function () {
                this.identificadorPro
                this.seriesCargadas = true,
                axios
                .post(process.env.VUE_APP_API_URL + 'usuario/series/'+ this.selected, {
                    token: this.$store.getters.userToken
                })
                .then(response => (
                    this.listaSeries = response.data.data,
                    this.rolSeries = response.data.rol,
                    this.seriesCargadas = false,
                    this.igvGlobal = response.data.igv
                ))
                .catch(error => {
                    this.seriesCargadas = false
                })
            },
            initDocument: function () {
                this.selected = 2
            },

            emitirOP(){
                this.emitiendo = true
                let ruta = ''
                this.ticket.token = this.$store.getters.userToken
                if(this.selected==1){
                    this.ticket.receptor.nro = this.receptor.numero.toString()
                    this.ticket.receptor.tipo = '6'
                    this.ticket.receptor.razonSocial = this.receptor.razonSocial
                    this.ticket.receptor.direccionFiscal = this.receptor.direccion
                    this.ticket.adicional.dirAlternativa = this.receptor.direccion
                }else{
                    if(this.tipoDocumento==0){
                        this.ticket.receptor.nro = '-'
                        this.ticket.receptor.tipo = '0'
                        this.ticket.adicional.otroNombre = this.receptor.razonSocial
                        this.ticket.adicional.dirAlternativa = this.receptor.direccion
                    }else{
                        this.ticket.receptor.nro = this.receptor.numero
                        this.ticket.receptor.tipo = this.receptor.tipo
                        this.ticket.receptor.razonSocial = this.receptor.razonSocial
                        this.ticket.receptor.direccionFiscal = this.receptor.direccion
                        this.ticket.adicional.otroNombre = this.receptor.razonSocial
                        this.ticket.adicional.dirAlternativa = this.receptor.direccion
                    }
                } 
                if(this.indexSerie == 0){
                    this.ticket.serie = this.listaSeries[0]
                }else{
                    this.ticket.serie = this.listaSeries[this.indexSerie]
                }
                if (this.formadepago.codigo != "000") {
                    if (this.formadepago.codigo === "00") {
                        this.ticket.adicional.credito = this.cuotasCredito
                        this.ticket.adicional.montoPendientePagoCredito = this.totalcredito
                        this.ticket.adicional.nombreFormaPago = this.formadepago.nombre
                    } else {
                        this.ticket.adicional.formaPago = this.formadepago.codigo;
                        this.ticket.adicional.nombreFormaPago = this.formadepago.nombre
                    }
                }
                this.ticket.adicional.username = this.$store.getters.userData.username;
                this.ticket.montoTotalImpuestos = this.montoTotalImpuestos
                this.ticket.totalVentaGravada = parseFloat(this.gravado)
                this.ticket.sumatoriaIgv = this.montoTotalImpuestos
                this.ticket.importeTotal = this.importeTotal
                this.ticket.idOrdenPago = this.idOrdenPago
                this.ticket.tipoOperacion = '0101'
                if(this.femision != ''){
                    this.ticket.fechaEmision = this.$moment(this.femision).format('YYYY-MM-DD HH:mm:ss')
                }
                if(this.fvencimiento != ''){
                    this.ticket.adicional.fechaVencimiento = this.$moment(this.fvencimiento).format('YYYY-MM-DD')
                }
                this.ticket.items = this.items,
                this.ticket.adicional.tipo_igv = this.igvGlobal
                this.ticket.email = this.listaCorreos,
                this.ticket.tipoMoneda = this.moneda.codigo
                this.selected==1 ? ruta = 'facturas/emitir': ruta = 'boletas/emitir'
                axios
                .post(process.env.VUE_APP_API_URL + ruta, this.ticket)
                .then(response => (
                    this.emitiendo = false,
                    this.$snotify.success(response.data.msg, 'Exito'),
                    this.dataImpresion = response.data.response, 
                    this.dataImpresion.pago = this.pago,
                    this.dataImpresion.vuelto = this.vuelto,
                    this.dataImpresion.razonSocial = this.receptor.razonSocial,
                    this.dataImpresion.direccion = this.receptor.direccion,
                    this.dataImpresion.tiporeceptor = this.receptor.tipo,
                    this.dataImpresion.adicionales = this.adicionales,
                    this.dataImpresion.pagos = this.listaPagos,
                    this.dataImpresion.user = this.user,
                    this.modalimpresion = true,                
                    this.items=[],
                    this.totalcredito = 0.0,
                    this.cuotasCredito = [],
                    this.formadepago = {
                        codigo: "008",
                        nombre: 'Efectivo ventas menores'
                    },      
                    this.ticket= {
                    email: [],
                    tipoOperacion: '',
                    serie: '',
                    montoTotalImpuestos: 0.00,
                    totalVentaGravada: 0.00,
                    totalVentaExonerada: 0.00,
                    sumatoriaIgv: 0.00,
                    importeTotal: 0.00,
                    adicional: {
                        dirAlternativa: ''
                    },
                    items: [],
                    receptor: {
                        tipo: '',
                        nro: '',
                        razonSocial: '',
                        direccionFiscal: ''
                    },                              
                },
                this.listaPagos =[]                         
                ))
                .catch(error => (
                    this.$snotify.error(error.response.data.msg,'Error')
                ))
            },
            nuevaImpresion: function () {
                this.modalimpresion = false,
                this.pagarOrdenP=false
                this.listProformas()
                // this.vistaimpresion = false,
                // this.newimpresion = true,
                // this.initTicket()
            },
            print: function () {
                this.printweb = true
            },
            validarImporteTotal: function () {
                if(this.selected == 1){
                    this.emitirOP()
                }else{
                    if(this.totales.importeTotal >= 700 && this.tipoDocumento == '0'){
                        this.$swal({
                        title: 'Atención!!!',
                        text: 'El importe total supera los 700 Soles, debe ingresa número de documento.',
                        icon: 'warning',
                        buttons: true,
                        dangerMode: true
                        }).then((willDelete) => {
                            
                        })
                    }else{
                        if(this.selected != 12){
                            if(this.tipoDocumento != 0 && this.receptor.numero !=null && this.receptor.razonSocial !=null){                               
                                this.emitirOP()
                            }else if(this.tipoDocumento == '0' && this.totales.importeTotal < 700){
                                 this.emitirOP()                          
                            }else{
                                this.$snotify.warning('Completar los datos Receptor');
                            }                 
                        }else if(this.selected == 12){
                            if(this.tipoDocumento != 0 && this.receptor.numero !=null && this.receptor.razonSocial !=null){
                                this.emitirNV()
                            }else if(this.tipoDocumento == '0' && this.totales.importeTotal < 700){
                                this.emitirNV()
                            }else{
                                this.$snotify.warning('Completar los datos Receptor');
                            }                     
                        }                   
                    }
                }
            },
            addcuota(index,value){
                let sumatotales = 0
                sumatotales = parseFloat(this.totalcredito) + parseFloat(this.montoPagoCuota)
                if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
                if(this.totales.importeTotal >= this.montoPagoCuota ){
                    if(this.totales.importeTotal >= sumatotales){
                    let total = 0.0
                    let cuota = {
                    identificadorCuota:'',
                    fechaPagoCuota:'',
                    montoPagoCuota:'',
                    } 
                    cuota.identificadorCuota = this.numerador(this.cuotasCredito.length+1)
                    cuota.fechaPagoCuota = this.$moment(this.fechaPagoCuota).format("YYYY-MM-DD"),
                    cuota.montoPagoCuota = this.montoPagoCuota;
                    this.cuotasCredito.push(cuota)

                    this.cuotasCredito.forEach(function(element){
                    total += parseFloat(element.montoPagoCuota);
                    }) 
                    this.totalcredito = total
                    this.fechaPagoCuota = '',
                    this.montoPagoCuota = ''
                    }else{
                    this.$snotify.warning('El monto no debe ser mayor al importe total del documento');
                    sumatotales = 0
                    }  
                }else{
                    this.$snotify.warning('El monto no debe ser mayor al importe total del documento');
                    sumatotales = 0
                }
                }
            },
        deletecuota(index){ 
            let totalarray =''
            totalarray = this.cuotasCredito.length+1
            this.renameident(index)
            this.cuotasCredito.splice(index, 1);

            let total = 0.0
            this.cuotasCredito.forEach(function(element){
            total += parseFloat(element.montoPagoCuota);
            }) 
            this.totalcredito = total
        },
        renameident(index){ 
            for (let i=0;i < this.cuotasCredito.length; i++) {
                if(i > index){
                this.cuotasCredito[i].identificadorCuota = this.numerador(i)
                }
            }
        },
        modalcredito(){
            this.modalCredito = false
        },
        numerador(value){
            let cuotanom = value
            let cadenacuota = ''
        if(cuotanom >=1 && cuotanom <=9){
            cadenacuota = 'Cuota00'+ String(cuotanom)
        }else if(cuotanom >=10 && cuotanom <=99){
            cadenacuota = 'Cuota0'+ String(cuotanom)
        }else if(cuotanom >=100 && cuotanom <=999){
            cadenacuota = 'Cuota'+ String(cuotanom)
        }
        return cadenacuota;
        },
        vercreditos(){
            this.modalCredito = true
        },
        emitirNV(){
        let itemBlank = []
            if(this.loadNotaVenta()){
                axios
                .post(process.env.VUE_APP_API_URL + 'notaventa/insertar', {
                    token: this.$store.getters.userToken,
                    serie: this.listaSeries[this.indexSerie],
                    notaVenta: this.notaVenta,
                    idOrdenPago: this.idOrdenPago
                })
                .then(response => (
                    this.$snotify.success(response.data.msg,'Exito'),
                    this.dataImpresion = response.data.response,
                    this.dataImpresion.notaVenta.receptor.razonSocial = this.receptor.razonSocial,
                    this.dataImpresion.notaVenta.receptor.direccionFiscal = this.receptor.direccion,
                    this.dataImpresion.notaVenta.receptor.tipo = this.receptor.tipo,
                    this.dataImpresion.adicionales = this.adicionales,
                    this.dataImpresion.vuelto = this.vuelto,
                    this.dataImpresion.pagos = this.listaPagos,
                    this.modalimpresion = true,
                    this.vistaimpresion = true,
                    this.newimpresion = false,
                    this.action.reset = true,

                    this.items=[],
                    this.totalcredito = 0.0,
                    this.cuotasCredito = [],
                    this.formadepago = {
                        codigo: "008",
                        nombre: 'Efectivo ventas menores'
                    },
                    this.listaPagos =[]
                ))
                .catch(error => {
                    this.$snotify.error(error.response.data,'Error')
                })
            }   
        },
        loadNotaVenta: function () {
            this.notaVenta.receptor.tipo = this.tipoDocumento
            this.notaVenta.receptor.nro = this.receptor.numero
            this.notaVenta.receptor.razonSocial = this.receptor.razonSocial
            this.notaVenta.receptor.direccionFiscal = this.receptor.direccion
            this.notaVenta.moneda = this.moneda
            this.notaVenta.plazoentrega = this.plazoentrega
            this.notaVenta.formapago = this.tipoPago
            this.notaVenta.garantia = this.garantia
            this.notaVenta.telefono = this.telefono
            this.notaVenta.items = this.items
            this.notaVenta.totales = this.totales
            this.notaVenta.atencion = this.atencion
            this.notaVenta.observaciones = this.observaciones
            this.notaVenta.adicional.username = this.$store.getters.userData.username
            this.notaVenta.adicional.tipo_igv = this.igvGlobal
            this.notaVenta.adicional.codigoComprobante = '12'
            if(this.formadepago.codigo != '000'){
                if(this.formadepago.codigo === '00'){
                    this.notaVenta.adicional.credito = this.cuotasCredito
                    this.notaVenta.adicional.montoPendientePagoCredito = this.totalcredito
                    this.notaVenta.adicional.nombreFormaPago = this.formadepago.nombre
                }else{
                    this.notaVenta.adicional.formaPago = this.formadepago.codigo
                    this.notaVenta.adicional.nombreFormaPago = this.formadepago.nombre
                }
            }
            return true
        },
        OpenModalEdit(index,value){
            let t = this
            this.listaTag.forEach(element => {
                if(element.idTag == value.idTag){
                    t.tag3 = element.idTag
                 }
            }),
            this.tagOriginal = value.ordenPago.tag3
            this.actualizado = value.ordenPago.actualizado
            this.editItems = true;
            this.idOrdenPago = value.idOrdenPago
            this.items =  value.ordenPago.items
            this.editItemsOp = value
            setTimeout(() => this.pasarItems(), 200);
        },
        updateItem: function (index, item) {
            this.$store.commit('setitems', this.items)
            this.dataitem.estado = true
            this.dataitem.tipo = 1
            this.dataitem.index = index
            this.dataitem.item = item
        },
        insertItem: function (value) {
            this.$store.commit('setitems', value)
            this.items = this.$store.getters.getitems
            this.dataitem.tipo = 3
            this.dataitem.estado = false
        },
        pasarItems(){
            this.$store.commit('setitems', this.items)
        },
        updateProforma: function () {
            this.loadProforma()
            axios
            .post(process.env.VUE_APP_API_URL + 'ordenpago/actualizar', {
                token: this.$store.getters.userToken,
                id: this.idOrdenPago,
                ordenpago: this.ordenpago,
                pagado:0,
                idMovil:this.idMovil
            })
            .then(response => (
              this.actualizandoordenpago = false,
              this.$snotify.success(response.data.msg,'Exito'),
              this.tagOriginal = '',
              this.tag3 = '',
              this.initOP()
            ))
            .catch(error => {
              this.actualizandoordenpago = false,
              this.$snotify.error(error.response.data.msg,'Error')
            })
        },
        loadProforma: function () {
            this.nuevo = true;
            this.ordenpago.receptor.tipo = this.editItemsOp.ordenPago.receptor.tipo
            this.ordenpago.receptor.nro = this.editItemsOp.ordenPago.receptor.nro
            this.ordenpago.receptor.razonSocial = this.editItemsOp.ordenPago.receptor.razonSocial
            this.ordenpago.receptor.direccionFiscal = this.editItemsOp.ordenPago.receptor.direccionFiscal
            this.ordenpago.moneda = this.editItemsOp.ordenPago.moneda
            this.ordenpago.plazoentrega = this.editItemsOp.ordenPago.plazoentrega
            this.ordenpago.formapago = this.editItemsOp.ordenPago.formapago
            this.ordenpago.garantia = this.editItemsOp.ordenPago.garantia
            this.ordenpago.telefono = this.editItemsOp.ordenPago.telefono
            this.ordenpago.items = this.items
            this.ordenpago.totales = this.totales
            this.ordenpago.atencion = this.editItemsOp.ordenPago.atencion
            this.ordenpago.observaciones = this.editItemsOp.ordenPago.observaciones
            this.ordenpago.adicional.username = this.$store.getters.userData.username
            this.ordenpago.fvencimiento = this.editItemsOp.ordenPago.fvencimiento
            this.ordenpago.sistema = this.sistema
            if(this.tag3 == ''){
                this.ordenpago.tag3 = this.tagOriginal
            }else{
                this.ordenpago.tag3 = this.tag3.tag
            }
            if(this.actualizado >= 0){
                ++this.actualizado
            this.ordenpago.actualizado = this.actualizado
            }
            this.ordenpago.nuevo = this.nuevo
            return true
          },
          listTag: function() {
            axios
            .post(process.env.VUE_APP_API_URL + "tag/listar", {
                token: this.$store.getters.userToken,
                limit: "40",
                order: "desc"
            })
            .then(response => (
                (this.listaTag = response.data.data)
            ))
            .catch(error => (this.$snotify.error("Error")));
        },
        initOP: function () {
            this.items = []
            this.editItemsOp = {}
            this.editItems = false;
            this.listProformas()
            return true
        },
        deleteItem: function (index) {
            this.dataitem.estado = true
            this.dataitem.tipo = 2
            this.dataitem.index = index
        },
        mostrarItems(row, index,item){
            if(row.detailsShowing){
                row.toggleDetails()
                this.ordenPago[index].mostrardetalles = false
            }else{
                this.nuevo = false;        
                this.ordenPago[index].ordenPago.nuevo = false;
                this.ordenPago[index].mostrardetalles = true
                this.ordenPago[index].loading = true
                row.toggleDetails()
                this.updateProforma2(item)  
            }
        },
        updateProforma2: function (item) {
            this.loadProforma2(item)
            axios
            .post(process.env.VUE_APP_API_URL + 'ordenpago/actualizar', {
                token: this.$store.getters.userToken,
                id: item.idOrdenPago,
                ordenpago: this.ordenpago,
                pagado:0,
                idMovil:this.idMovil
            })
            .catch(error => {
              console.log(error.response.data.msg)
            })
        },
        loadProforma2: function (item) {
            this.ordenpago.receptor.tipo = item.ordenPago.receptor.tipo
            this.ordenpago.receptor.nro = item.ordenPago.receptor.nro
            this.ordenpago.receptor.razonSocial = item.ordenPago.receptor.razonSocial
            this.ordenpago.receptor.direccionFiscal = item.ordenPago.receptor.direccionFiscal
            this.ordenpago.moneda = item.ordenPago.moneda
            this.ordenpago.plazoentrega = item.ordenPago.plazoentrega
            this.ordenpago.formapago = item.ordenPago.formapago
            this.ordenpago.garantia = item.ordenPago.garantia
            this.ordenpago.telefono = item.ordenPago.telefono
            this.ordenpago.items = item.ordenPago.items
            this.ordenpago.totales = item.ordenPago.totales
            this.ordenpago.atencion = item.ordenPago.atencion
            this.ordenpago.observaciones = item.ordenPago.observaciones
            this.ordenpago.adicional.username = this.$store.getters.userData.username
            this.ordenpago.fvencimiento = item.ordenPago.fvencimiento
            this.ordenpago.sistema = this.sistema
            // this.ordenpago.tag3 = this.tag3.tag
            this.ordenpago.tag3 = item.ordenPago.tag3
            this.ordenpago.nuevo = this.nuevo
            this.ordenpago.actualizado = item.ordenPago.actualizado
            return true
        },
        rowClass(item,type){
            if (!item || type !== 'row') return
            if (item.ordenPago.nuevo === true) return 'table-success'
        }
    }
}

</script>
<style scoped>
.bordes{
    margin-top: 10px;
    margin-right: 15px;
    border: 2px solid #ccc;
    border-radius: 10px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
}
.pagos{
    margin-left: 13px;
    min-height: 273px;
    padding-right: 10px;
}
.searcher-field{
    z-index: 1000;
    position: absolute;
    max-height: 400px !important;
    overflow-y: scroll;
    width: 500px
}
.searcher-result{
    font-size: smaller;
    padding: 2px 0px 2px 0px;
    cursor: pointer;
}
/*label*/
.form-label-group input::-webkit-input-placeholder {
  color: transparent;
}

.form-label-group input:-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-moz-placeholder {
  color: transparent;
}

.form-label-group input::placeholder {
  color: transparent;
}

.form-label-group input:not(:placeholder-shown) {
  padding-top: 1.25rem;
  padding-bottom: .25rem;
}

.form-label-group input:not(:placeholder-shown) ~ label {
  padding-top: .25rem;
  padding-bottom: .25rem;
  font-size: 9px;
  color: #00B261;
}
.form-label-group {
  position: relative;
  /* margin-bottom: 1rem; */
}
.form-label-group > input,
.form-label-group > label {
  padding: .75rem;
}

.form-label-group > label {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0; /* Override default `<label>` margin */
  line-height: 1.5;
  color: #495057;
  pointer-events: none;
  cursor: text; /* Match the input under the label */
  border: 1px solid transparent;
  border-radius: .25rem;
  transition: all .1s ease-in-out;
}
</style>